export interface UserStats {
  userName: string
  brokerUserName: string
  customerName: string
  totalMinutes: number
  totalTrades: number
  annualCustomerVolume: number
  dataForDate: Record<string, MinutesAndTradesForDay>
}

export interface MinutesAndTradesForDay {
  minutes: number
  trades: number
}

export interface UserDataReport {
  reportDate: Date
  userStats: UserStats[]
}

export interface ManagementReport {
  reportDate: Date
  webMakerOrders: number
  webTradeTickets: number
  apiTradeTickets: number
  citrixTickets: number
  allTradeTickets: number
  uniqueWebUsers: number
  totalCitrixUsers: number
  bondsComCitrixUsers: number
  customerCitrixUsers: number
  topWebTraders: WebTradeData[]
  topWebMarketMakers: WebMarketMakerData[]
  allUsers: string[]
}

export const EmptyManagementReport = {
  reportDate: new Date(),
  webMakerOrders: 0,
  webTradeTickets: 0,
  apiTradeTickets: 0,
  citrixTickets: 0,
  allTradeTickets: 0,
  uniqueWebUsers: 0,
  totalCitrixUsers: 0,
  bondsComCitrixUsers: 0,
  customerCitrixUsers: 0,
  topWebTraders: [],
  topWebMarketMakers: [],
  allUsers: []
}

export interface WebTradeData {
  customerName: string
  userName: string
  tradeCount: number
}

export interface WebMarketMakerData {
  customerName: string
  userName: string
  orderCount: number
}
